function getScale(item, scroll) {
  return 1 + ((item.getBoundingClientRect().top + window.scrollY - scroll) / window.innerHeight);
}

function isInViewport(el, st) {
  return !(1 + ((el.getBoundingClientRect().top + window.scrollY - st) / window.innerHeight) < 1
    || (el.getBoundingClientRect().top + window.scrollY - st) - window.innerHeight > 1);
}

window.addEventListener('scroll', () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const items = window.document.querySelectorAll('.js-item-thumb');

  items.forEach((item) => {
    const figure = item.querySelector('.js-figure');
    const scale = getScale(item, scrollTop);

    if (!isInViewport(item, scrollTop)) {
      return false;
    }

    figure.style.transform = `scale(${scale}) translateZ(0px)`;

    return true;
  });
});
